// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getFirestore } from "firebase/firestore";

// Configurazione letta dall'ambiente: frontend/.env.production (produzione),
// .env.development (sviluppo locale), .env.beta (build beta).
//
// ⚠️ Nessun valore di ripiego, di proposito: un default punterebbe al progetto
// di produzione "app-qpsc" e una beta mal configurata finirebbe a leggere e
// scrivere dati reali di minori. Meglio un errore esplicito. Vedi CLAUDE.md §2.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  // Facoltativo: Analytics non è attivo sul progetto beta.
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || undefined
};

const chiaviObbligatorie = [
  "apiKey",
  "authDomain",
  "projectId",
  "storageBucket",
  "messagingSenderId",
  "appId"
];

const mancanti = chiaviObbligatorie.filter((chiave) => !firebaseConfig[chiave]);
if (mancanti.length > 0) {
  throw new Error(
    `Configurazione Firebase incompleta: mancano ${mancanti.join(", ")}. ` +
    "Verifica il file .env dell'ambiente in uso (frontend/.env.production, " +
    ".env.development o .env.beta) e ricompila."
  );
}

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export const auth = getAuth(app);
// ⚠️ RL-8b: qui stavano `googleProvider` (GoogleAuthProvider) e
// `phoneProvider` (PhoneAuthProvider). L'accesso passa ora dal solo link via
// email: il primo aveva come unico importatore in tutto frontend/src la
// vecchia Login.jsx, il secondo non ne aveva già nessuno. Verificato con una
// ricerca su tutto frontend/ (escluse node_modules e build) prima di
// toglierli. Non se ne rimettano senza un motivo scritto.

// PERSISTENZA DELLA SESSIONE: quella predefinita di getAuth (SESS-1/SESS-2).
//
// getAuth prova nell'ordine IndexedDB, localStorage, sessionStorage: la
// sessione sopravvive comunque alla chiusura del browser. Qui stava una
// chiamata che imponeva localStorage, creduta uguale al predefinito e
// non lo era: a ogni avvio la sessione passava da localStorage
// a IndexedDB e poi tornava indietro. Tolto; le sessioni già salvate in
// localStorage l'SDK le trova e le sposta da sé in IndexedDB.

export { messaging, getToken, onMessage };
export const db = getFirestore(app);

// Nome del bucket Storage dell'ambiente in uso.
//
// ⚠️ Non usarlo più per comporre a mano URL pubblici dei file: lo Storage è
// chiuso in lettura (storage.rules) e foto e documenti passano solo dal
// backend con fetch autenticata (vedi src/components/AuthAvatar.jsx).
// Resta esportato perché serve come riferimento del bucket in uso.
export const storageBucket = firebaseConfig.storageBucket;